// extracted by mini-css-extract-plugin
module.exports = {"alreadyRequestedExams":"AlreadyRequestedBox_alreadyRequestedExams__3jo5C"};